import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { JobService } from 'src/services/api/JobService';

const STALE_TIME = 1000 * 60 * 5; // 5 minutes

export function useJobs() {
  return useQuery({
    queryKey: ['jobs'],
    queryFn: JobService.getJobs,
    staleTime: STALE_TIME,
  });
}

export function useJobById(id) {
  return useQuery({
    queryKey: ['job', id],
    queryFn: () => JobService.getJobById(id),
    enabled: !!id,
    staleTime: STALE_TIME,
  });
}

/**
 * Apply to a job. On success, invalidate the job's detail + the jobs list so
 * any applied/eligibility state re-fetches instead of showing stale data.
 */
export function useApplyToJob() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ jobId, payload }) => JobService.applyToJob(jobId, payload),
    onSuccess: (_data, { jobId }) => {
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
    },
  });
}
